/* eslint @backstage/no-undeclared-imports: 0 */
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { EDSCheckboxGroup } from './CheckboxGroupExtension';

export const edsCheckboxGroupField = {
  name: 'EDSCheckboxGroup',
  component: EDSCheckboxGroup,
};

export const EDSCheckboxGroupFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension(edsCheckboxGroupField),
);
